<section>
    <img class="img--style" [src]=data.img alt="Comercio Aliado Approbe">
    <h3>{{data.description}}</h3>
    <p *ngIf="data.descriptionSmall != '' ">{{data.descriptionSmall}}</p>
    <button (click)="close()">{{data.button}}</button>
</section>